
  <mat-horizontal-stepper linear="true" #stepper>
    <mat-step [stepControl]="formStepeOne">
      <form [formGroup]="formStepeOne">
        <ng-template class="font" matStepLabel>Equipo</ng-template>
        <div style="display: flex; flex-direction: column; align-items: center; margin-top:5px;">

          <app-button-label [labels]="labels">
          </app-button-label>

            <div style="width:100%; padding:10px;">
              <data-table 
                title='' 
                [columns]='columnasEquipos' 
                [configuration]='configurationEquipos'
                [reloadTable]='recargarTablaEquipos' 
                (clickRow)='clickFilaEquipos($event)' 
                [params]="[{ id: 'state', value: 1 }]"
                [url]='urlTablaEquipos'>
              </data-table>
            </div>

            <div style="display: none">
              <mat-form-field>
                <input autocomplete="off" type="text" formControlName='equipmentId' matInput required>
              </mat-form-field>
            </div>

          <button matStepperNext style="width: 70%; margin: 15px 0 15px 0;" color="primary"
            class="button-save mat-elevation-z5 " mat-raised-button>Aceptar</button>

        </div>


      </form>
    </mat-step>

    <mat-step>
      <ng-template class="font" matStepLabel>Orden</ng-template>
      <form [formGroup]="formStepeTwo" (ngSubmit)="formStepeTwo.valid?form(formStepeTwo.value):errorMessage()">
        <div style="display: flex; flex-direction: column; align-items: center; margin-top:10px;">

          <h1>Solicitud de combustible</h1>
          <app-button-label [labels]="labels">
          </app-button-label>

          <div class="first-row" style="width: 100%;">

            <div class="row-item" style='width:100%;'>
              <mat-form-field [appOpenDatepickerOnClick]="picker">
                  <mat-label>Fecha</mat-label>
                  <input matInput [matDatepicker]="picker" autocomplete="off" matInput
                      required formControlName='date' required
                      (ngModelChange)="checkDateRange($event)">
                  <mat-datepicker-toggle matIconSuffix [for]="picker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker [touchUi]='movil?true:false'></mat-datepicker>
              </mat-form-field>
          </div>

            <!-- <div class="row-item">
              <mat-form-field>
                <input autocomplete="off" type="text" matInput formControlName='description' placeholder="Comentarios" #descripcion maxlength="255">
                <mat-hint>{{descripcion.value.length}}/255</mat-hint>
              </mat-form-field>
            </div> -->

          </div>

          <button style="width: 70%; margin: 15px 0 10px 0;" color="primary" class="button-save mat-elevation-z5 "
            mat-raised-button type="submit">Enviar</button>

        </div>

      </form>

    </mat-step>



  </mat-horizontal-stepper>
